module.exports = __webpack_public_path__ + "img/hear_png.8d6ca016.png";